export default __webpack_public_path__ + "static/media/toy4.95c174cb.jfif";